import { render, staticRenderFns } from "./AddCertificateForm.vue?vue&type=template&id=34c00e50&"
import script from "./AddCertificateForm.vue?vue&type=script&lang=js&"
export * from "./AddCertificateForm.vue?vue&type=script&lang=js&"
import style0 from "./AddCertificateForm.vue?vue&type=style&index=0&id=34c00e50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports